export const getTransKeyByItemType = (baseKey, itemType) => {
  return itemType ? `${baseKey}.${itemType}` : baseKey;
};
//# sourceMappingURL=get-translate-key-by-item-type.js.map